import React from 'react';

import { makeStyles, createStyles } from '@material-ui/core/styles';

import {
    Theme, Box, FormControl, FormLabel, Typography,
    FormControlLabel, Radio, RadioGroup, SvgIconProps,
    ButtonProps, TextFieldProps, TypographyProps, Container, TextField,
} from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            flexFlow: 'row wrap',
            border: `solid 1px ${theme.palette.divider}`,
            justifyContent: 'space-around',
        },
        controlGroup: {
            display: 'flex',
            flexFlow: 'row wrap',
            boxShadow: theme.shadows[1],
            padding: theme.spacing(2),
            '&:hover': {
                boxShadow: theme.shadows[4],
            },
        },
        controls: {
            padding: theme.spacing(1),
        },
    }),
);

export type BoolPropTypes = 'true' | 'false';

export type ControlPropTypes = ButtonProps['color'] | ButtonProps['variant'] | TextFieldProps['color'] | TextFieldProps['variant'] |
    TextFieldProps['size'] | BoolPropTypes | TypographyProps['variant'] | SvgIconProps['fontSize'] | string;

export interface ConfigControlGroups {
    name: string;
    controlGroups: (RadioButtonControl | TextControl)[];
}

export interface RadioButtonControl {
    label: string;
    name: string;
    value: ControlPropTypes;
    changeHandler: (event: React.ChangeEvent<HTMLInputElement>) => void;
    radioButtons: string[];
}

export interface TextControl {
    id: string;
    label: string;
    name: string;
    value: ControlPropTypes;
    changeHandler: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

interface AlmeConfigFormControlProps {
    title: string;
    configControls: ConfigControlGroups[];
}

const AlmeConfigFormControl: React.FC<AlmeConfigFormControlProps> = (props: AlmeConfigFormControlProps) => {
    const classes = useStyles();

    const isRadioControl = (control: RadioButtonControl | TextControl): boolean => {
        return (control as RadioButtonControl).radioButtons && (control as RadioButtonControl).radioButtons.length > 0;
    };

    const isTextControl = (control: RadioButtonControl | TextControl): boolean => {
        return !!(control as TextControl).id && !isRadioControl(control);
    };

    return (
        <Container className={classes.root}>
            <Typography variant="subtitle1">{props.title}</Typography>
            {props.configControls.map((controls, i1) => (
                <Box key={i1} className={classes.controlGroup}>
                    {controls.controlGroups.map((control, i2) => (
                        <Box key={i2} className={classes.controls}>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">{control.label}</FormLabel>
                                {isRadioControl(control) &&
                                    <RadioGroup aria-label={control.label} name={control.name} value={control.value} onChange={control.changeHandler}>
                                        {(control as RadioButtonControl).radioButtons.map((radioValue, i3) => (
                                            <FormControlLabel key={i3} value={radioValue} control={<Radio />} label={radioValue} />
                                        ))}
                                    </RadioGroup>
                                }
                                {isTextControl(control) &&
                                    <TextField
                                        id={(control as TextControl).id}
                                        label={control.label}
                                        aria-label={control.label}
                                        name={control.name}
                                        value={control.value || ''}
                                        onChange={control.changeHandler} />
                                }
                            </FormControl>
                        </Box>
                    ))}
                </Box>
            ))}
        </Container>
    );
};

export default AlmeConfigFormControl;